import {Component, Input} from '@angular/core';
import {PROFILE_STATE, FOURSTOP_STATUS} from '../../../../../../common/constants';

@Component({
    selector: 'tfl-bo-fourstop-state-badge',
    template: `
        <span [ngClass]="fourstopBadgeClass">
            {{ fourstopBadgeTitle | translate }}
        </span>
    `
})
export class FourStopProcessingBadgeComponent {

    fourstopBadgeClass: any = {};
    fourstopBadgeTitle: string = '';

    @Input('processedByFourStop')
    set _processedByFourStop(processedByFourStop: boolean) {
        this.fourstopBadgeClass = this.getStateBadgeClass(processedByFourStop);
        this.fourstopBadgeTitle = this.getStateBadgeTitle(processedByFourStop);
    }

    private getStateBadgeClass(state: boolean): any {
        return {
            'label        ': true,
            'label-info': state === FOURSTOP_STATUS.PROCESSED_BY_FOURSTOP
        };
    }

    private getStateBadgeTitle(state: boolean): string {
        switch (state) {
            case FOURSTOP_STATUS.PROCESSED_BY_FOURSTOP:
                return 'CUSTOMER.STATE.4STOP_PROCESSING';
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/fourstop.state.badge.component.ts